export const getTopLevelHeaderName = (sectionName, navData = {}) => {
  const { primaryNav = [] } = navData;
  const primarySection = primaryNav.find(({ stringId = '' }) => (
    stringId === sectionName || stringId === `msg_${sectionName}`
  ));

  const sectionIdName = (sectionName || '').replace(/^msg_/, '');

  return (primarySection && primarySection.label) || sectionIdName;
};

export const getSubLevelHeaderName = (quickLink) => {
  const labelFromIconText = quickLink.querySelector('.shared-nav-icon-text');
  const label = labelFromIconText
    ? labelFromIconText.textContent
    : quickLink.textContent;

  return (label || '').trim();
};

export const getSectionName = (quickLink) => {
  let sectionName = '';
  const stringIdMarker = 'msg_';
  const parentEl = quickLink.closest('.shared-nav__secondary-parent');

  if (!parentEl) {
    return sectionName;
  }

  parentEl.classList.forEach((className) => {
    const markerIndex = className.indexOf(stringIdMarker);
    if (markerIndex !== -1) {
      sectionName = className.slice(markerIndex + stringIdMarker.length);
    }
  });

  return sectionName;
};
